import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Card, TableRow } from '@mui/material';
import TableCell from 'src/components/Table/TableCell';
import { useTranslation } from 'react-i18next';
import Table from 'src/components/Table';
import { useSelector } from 'react-redux';
import { isLoadingSelector } from 'src/store/selectors/statusSelector';
import { LOAD_CONTRACT_EVENTS } from 'src/store/actions/contractActions';
import NotFoundRecords from 'src/components/NotFoundRecords';
import ContractEventsRow from './ContractEventsRow';

const Tbody = ({ contractEvents }) =>
  contractEvents.map(cal => <ContractEventsRow key={cal.id} {...cal} />);

const ContractEventsTable = ({ className, contractEvents, ...rest }) => {
  const { t } = useTranslation();

  const loading = useSelector(isLoadingSelector([LOAD_CONTRACT_EVENTS.action]));

  const theads = useMemo(
    () => () => (
      <TableRow>
        <TableCell variant="head" align="center">
          {t('CONTRACT_VIEW.CONTRACT_DETAIL.PERIOD')}
        </TableCell>
        <TableCell variant="head" align="center" style={{ minWidth: '10rem' }}>
          {t('COMMON.CLIENT')}
        </TableCell>
        <TableCell variant="head" align="center">
          {t('COMMON.STATUS')}
        </TableCell>
        <TableCell variant="head" align="center" style={{ minWidth: '10rem' }}>
          {t('CONTRACT_VIEW.EVENTS.EVENT_TYPE')}
        </TableCell>
      </TableRow>
    ),
    [t]
  );

  const tbody = useMemo(
    () => () => <Tbody t={t} contractEvents={contractEvents} />,
    [contractEvents, t]
  );

  if (!loading && !contractEvents.length) {
    return (
      <Card>
        <NotFoundRecords
          title="NOT_FOUND_RECORDS_MESSAGE.CONTRACT_EVENTS_TITLE"
          description="NOT_FOUND_RECORDS_MESSAGE.CONTRACT_EVENTS_DESCRIPTION"
        />
      </Card>
    );
  }

  return (
    <Table
      {...rest}
      variant="outlined"
      tbody={tbody}
      theads={theads}
      loading={loading}
    />
  );
};

ContractEventsTable.propTypes = {
  className: PropTypes.string,
  contractEvents: PropTypes.array.isRequired
};

export default ContractEventsTable;
